import pepperAssetFinance from './pepperAssetFinanceAuth.component';

export default angular
  .module('st.Integrations.PepperAssetFinance', [])
  .component('pepperAssetFinance', pepperAssetFinance);
